const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';

export const sendReservationRequest = async (formData) => {
  const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

  if (!accessKey) {
    return {
      success: false,
      message: 'Reservierung konnte nicht gesendet werden. Web3Forms Access Key fehlt.'
    };
  }

  const payload = new FormData();

  payload.append('access_key', accessKey);
  payload.append('subject', `Neue Reservierungsanfrage von ${formData.name}`);
  payload.append('from_name', 'Stadtheuriger zum Brückl');
  payload.append('name', formData.name);
  payload.append('email', formData.email);
  payload.append('Name', formData.name);
  payload.append('Telefon', formData.phone);
  payload.append('E-Mail', formData.email);
  payload.append('Datum', formData.date);
  payload.append('Uhrzeit', formData.time);
  payload.append('Personen', formData.persons);
  payload.append('Nachricht', formData.message || '-');
  payload.append('Datenschutzhinweis bestätigt', formData.privacyAccepted ? 'Ja' : 'Nein');
  payload.append('botcheck', formData.botcheck || '');

  payload.append(
    'message',
    `
Neue Reservierungsanfrage über die Website:

Name: ${formData.name}
Telefon: ${formData.phone}
E-Mail: ${formData.email}
Datum: ${formData.date}
Uhrzeit: ${formData.time}
Personen: ${formData.persons}

Nachricht:
${formData.message || '-'}

Datenschutzhinweis bestätigt: ${formData.privacyAccepted ? 'Ja' : 'Nein'}
    `.trim()
  );

  try {
    const response = await fetch(WEB3FORMS_ENDPOINT, {
      method: 'POST',
      body: payload
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      return {
        success: false,
        message: data.message || 'Reservierung konnte nicht gesendet werden. Bitte telefonisch reservieren.'
      };
    }

    return {
      success: true,
      message: 'Vielen Dank! Ihre Reservierungsanfrage wurde erfolgreich gesendet. Wir melden uns zur Bestätigung.'
    };
  } catch (error) {
    return {
      success: false,
      message: 'Reservierung konnte nicht gesendet werden. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns telefonisch.'
    };
  }
};